export const getFlashes = (state) => state.flashes;
